/** name="value" with the least ugly quoting (prefers a single-quoted attr over &quot;) */
export const mdxAttr = (name, value) => {
  const v = String(value ?? '');
  if (!v.includes('"')) return `${name}="${v}"`;
  if (!v.includes("'")) return `${name}='${v}'`;
  return `${name}="${v.replace(/"/g, '&quot;')}"`;
};
